import { render, staticRenderFns } from "./CookiesPolicePopup.vue?vue&type=template&id=13d2aba4&scoped=true&"
import script from "./CookiesPolicePopup.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicePopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPolicePopup.vue?vue&type=style&index=0&id=13d2aba4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2aba4",
  null
  
)

export default component.exports